import React, {useEffect} from "react";
import {
  withSitecoreContext
} from "@sitecore-jss/sitecore-jss-react";
import "./index.scss";


const SiteUsersRouterModule = (props) => {

  const hasToRedirect: boolean = !props?.fields?.["UserAuthorized"];

  useEffect(() => {
     if (typeof window != "undefined" && hasToRedirect) {
       window.location.href = props?.fields?.["RedirectUrl"];
     }
   }, []);
    

  return (
    <>
    </>
  );
};

export default withSitecoreContext()(SiteUsersRouterModule);
